export default "__VITE_ASSET__Bb1oAPO9__"